export const KeyboardCombos = {
  CtrlAltI: 'ctrl+alt+i',
  CtrlAltK: 'ctrl+alt+k',
  CtrlAltJ: 'ctrl+alt+j',
  CtrlAltL: 'ctrl+alt+l',
  CtrlAltM: 'ctrl+alt+m',
  CtrlAltN: 'ctrl+alt+n',
  CtrlAltH: 'ctrl+alt+h',
  CtrlSpace: 'ctrl+space'
};
